<template>
  <el-row
    type="flex"
    justify="center"
    align="middle"
    class="fill-height text--center"
  >
    <el-col class="forgot" :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
      <img
        class="login-banner"
        src="@/assets/LoginBanner.png"
        alt="banner-events"
      />
      <div class="mb-2">
        <el-card shadow="always">
          <templete>
            <div v-if="verified">
              <h3>{{ $t("emailVerified.successTitle") }}</h3>
              <el-row
                type="flex"
                justify="center"
                align="middle"
                class="fill-height text--center"
              >
                <p>{{ $t("emailVerified.successDescription") }}</p>
              </el-row>
            </div>
            <div v-else>
              <h3>{{ $t("emailVerified.errorTitle") }}</h3>
              <el-row
                type="flex"
                justify="center"
                align="middle"
                class="fill-height text--center"
              >
                <p>{{ $t("emailVerified.errorDescription") }}</p>
              </el-row>
            </div>
          </templete>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { auth } from "@/config/firebase";
import { showMessage } from "@/services/MessageService";
import { i18n } from "@/i18n";

export default {
  setup() {
    const actionCode = ref(null);
    const route = useRoute();
    const verified = ref(false);

    const validParametersEmailVerified = async () => {
      if (route.query.oobCode) {
        actionCode.value = route.query.oobCode;
        try {
          await auth.applyActionCode(route.query.oobCode);
          verified.value = true;
        } catch (error) {
          verified.value = false;
          showMessage({
            title: i18n.global.t("emailVerified.erorCodeTitle"),
            message: i18n.global.t("emailVerified.errorCode") + error.message,
            type: "warning",
          });
        }
      } else {
        verified.value = false;
      }
    };
    onMounted(validParametersEmailVerified);

    return { verified };
  },
};
</script>
<style scoped>
.login-banner {
  width: 100%;
  object-fit: contain;
  max-block-size: 250px;
}
.forgot {
  margin: auto;
  padding: 1rem;
}
.box-card {
  text-align: center;
}
</style>
